import { Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { useDialog } from 'apps/app/src/hooks/use-dialog';
import React from 'react';
import { NetSuiteExportContractDialog } from './NetSuiteExportContractDialog/NetSuiteExportContractDialog';

type MenuItemNetSuiteExportContractProps = {
  contractId: string;
  planId: string;
  disabled?: boolean;
  isSynced: boolean;
};

export const MenuItemNetSuiteExportContract: React.FC<MenuItemNetSuiteExportContractProps> = ({ contractId, disabled, isSynced }) => {
  const { isDialogOpen, handleOpen, handleClose } = useDialog();

  return (
    <>
      <MenuItem
        className='pb-2'
        disabled={disabled}
        onClick={handleOpen}
      >
        <Typography>ERP Sales Order Sync</Typography>
      </MenuItem>
      <NetSuiteExportContractDialog
        isSynced={isSynced}
        open={isDialogOpen}
        onClose={handleClose}
        contractId={contractId}
      />
    </>
  );
};